import { useNavigate } from "react-router-dom";
import { toast } from "../client/hooks/use-toast";
import useTranslation from "../client/hooks/useTranslation";

/**
 * Toast affiché après une création / un import de trades quand le serveur a
 * auto-détecté une ou plusieurs sessions. Partagé par la création manuelle et
 * l'import CSV (anciennement inline dans TradingJournalPage).
 */
export function useAutoDetectSessionToast() {
  const t = useTranslation();
  const navigate = useNavigate();

  return function handleAutoDetectResult(autoDetectResult: any) {
    if (!autoDetectResult) return;

    if (autoDetectResult.skippedDueToLimit > 0) {
      toast({ title: t.sessions.autoDetectedLimitReached, variant: "destructive" });
      return;
    }

    const created = autoDetectResult.created ?? [];
    if (created.length === 0) return;

    if (created.length === 1) {
      const session = created[0];
      const start = new Date(session.startedAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
      const end = new Date(session.endedAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
      const message = t.sessions.autoDetected.replace("{start}", start).replace("{end}", end);
      toast({
        title: message,
        action: (
          <button
            className="text-primary underline text-sm"
            onClick={() => navigate(`/session/${session.sessionId}`)}
          >
            {t.sessions.autoDetectedViewSession}
          </button>
        ),
      });
    } else {
      toast({ title: t.sessions.autoDetectedMultiple.replace("{count}", String(created.length)) });
    }
  };
}
